import state from './moduleServicesState.js'
import mutations from './moduleServicesMutations.js'
import actions from './moduleServicesActions.js'
import getters from './moduleServicesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}